export default __webpack_public_path__ + "static/media/large_en.c99ff8e6.jpg";